import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RmaIconComponent, RmaIcons } from '@rma/public/generic/ui/icon';
import { CALLOUT_CONFIG, CalloutType, DEFAULT_CALLOUT_TYPE } from './callout-config';

@Component({
  selector: 'rma-callout',
  imports: [MatButtonModule, RmaIconComponent],
  templateUrl: './callout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutComponent implements OnChanges {
  @Input()
  calloutType: CalloutType = DEFAULT_CALLOUT_TYPE;

  @Input()
  message: string | null = null;

  @Input()
  isHtml = false;

  @Input()
  duration: number | undefined = undefined;

  @Input()
  dismissible = false;

  @Output()
  dismiss = new EventEmitter<void>();

  @HostBinding('class')
  classes = this.getHostStyle(this.calloutType ?? DEFAULT_CALLOUT_TYPE);

  icon: { icon: RmaIcons; class: string } = this.getIcon(this.calloutType ?? DEFAULT_CALLOUT_TYPE);

  ngOnChanges(changes: SimpleChanges): void {
    const { calloutType } = changes;

    if (calloutType) {
      this.classes = this.getHostStyle(this.calloutType ?? DEFAULT_CALLOUT_TYPE);
      this.icon = this.getIcon(this.calloutType ?? DEFAULT_CALLOUT_TYPE);
    }
  }

  private getStyleConfig(calloutType: CalloutType) {
    return CALLOUT_CONFIG[calloutType];
  }

  private getHostStyle(calloutType: CalloutType) {
    const styleConfig = this.getStyleConfig(calloutType);

    return `flex items-center p-3 pr-4 text-steel-100 rounded shadow-md space-x-3 ${styleConfig.backgroundStyle}`;
  }

  private getIcon(calloutType: CalloutType): { icon: RmaIcons; class: string } {
    const styleConfig = this.getStyleConfig(calloutType);

    return {
      icon: styleConfig.icon,
      class: `flex items-center justify-center ${styleConfig.backgroundStyle} ${styleConfig.iconColor}`,
    };
  }
}
